import { setPaymentGates, setCurrentPaymentGate } from '.';

const restoreState = ({ currentGate, paymentGates }) => (dispatch) => {
  dispatch(setPaymentGates(paymentGates));
  dispatch(setCurrentPaymentGate(currentGate));
};

export default restoreState;
